module.exports = __webpack_public_path__ + "img/SEND_MESSAGE.c183fc8e.svg";